import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import {
  addProfileForm,
  editProfileForm,
} from "../../../../../../store/profile-form/thunkAction";
import {
  sendNotifyIziMessageError,
  sendNotifyIziMessageSuccess,
} from "../../../../../../utils/event";

const FormConfig = () => {
  const params = useParams();
  const profileId = _.get(params, "id");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profileFormManage = useSelector((state) => state.profileFormManage);
  const profileForm = _.get(profileFormManage, "profileForm");
  const profileFormId = _.get(profileForm, "_id");
  const isLoadingAddProfileForm = _.get(
    profileForm,
    "isLoadingAddProfileForm",
    false
  );

  const [greeting, setGreeting] = useState("");
  const [isPreChat, setIsPreChat] = useState(false);
  const [isAgentActiveChat, setIsAgentActiveChat] = useState(false);
  const [isConnectionFrames, setIsConnectionFrames] = useState(false);
  const [trustedHost, setTrustedHost] = useState("");

  useEffect(() => {
    const preChat = _.get(profileForm, "preChat", {});
    const frame = _.get(profileForm, "frame", {});

    setGreeting(_.get(preChat, "greeting", ""));
    setIsPreChat(_.get(preChat, "isPreChat", false));
    setIsAgentActiveChat(_.get(preChat, "isAgentActiveChat", false));

    setIsConnectionFrames(_.get(frame, "isConnectionFrames", false));
    setTrustedHost(_.get(frame, "trustedHost", ""));
  }, [profileForm]);

  const saveForm = async () => {
    const preChat = {
      greeting,
      isPreChat,
      isAgentActiveChat,
    };
    const frame = {
      isConnectionFrames,
      trustedHost,
    };

    try {
      if (profileFormId) {
        await dispatch(
          editProfileForm({
            id: profileFormId,
            data: {
              preChat,
              frame,
            },
          })
        ).unwrap();
        sendNotifyIziMessageSuccess(t("profile.profile_form_save_success"));

        return;
      }

      const data = {
        profileId,
        preChat,
        frame,
        fields: [],
      };

      if (isLoadingAddProfileForm) {
        return;
      }

      await dispatch(addProfileForm(data)).unwrap();
      sendNotifyIziMessageSuccess(t("profile.profile_form_save_success"));
    } catch (error) {
      sendNotifyIziMessageError(t("profile.profile_form_save_error"));
    }
  };

  return (
    <div className="tab-content" id="livestreamTabContent">
      <div
        className="tab-pane fade active show"
        id="configurations-tab-pane"
        role="tabpanel"
        aria-labelledby="configurations-tab"
        tabIndex="0"
      >
        <div className="row">
          <div className="col-lg-3">
            <h5 className="title">
              {t("settings.profile.profile_form.pre_chat_form")}
            </h5>
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              <div className="col-md-3">
                <label className="form-label text-uppercase">
                  {t("settings.form.preChat")}
                </label>
                <label className="form-check form-switch gap-2 d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={isPreChat}
                    onChange={(e) => setIsPreChat(e.target.checked)}
                  />
                  <span>{t("common.active")}</span>
                </label>
              </div>
              <div className="col-md-4">
                <label className="form-label text-uppercase">
                  {t("settings.profile.profile_form.agent_can_active_chat")}
                </label>
                <label className="form-check form-switch gap-2 d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={isAgentActiveChat}
                    onChange={(e) => setIsAgentActiveChat(e.target.checked)}
                  />
                  <span>{t("common.active")}</span>
                </label>
              </div>
              <div className="col-12">
                <label className="form-label text-uppercase">
                  {" "}
                  {t("settings.profile.profile_form.greetings")}
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={greeting}
                  onChange={(e) => setGreeting(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <hr className="mb-4 mt-4" />
        <div className="row mb-5">
          <div className="col-lg-3">
            <h5 className="title">
              {t("settings.profile.profile_form.frame_interface")}
            </h5>
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              <div className="col-12">
                <label className="form-label text-uppercase">
                  {t("settings.profile.profile_form.connection_between_frames")}
                </label>
                <label className="form-check form-switch gap-2 d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={isConnectionFrames}
                    onChange={(e) => setIsConnectionFrames(e.target.checked)}
                  />
                  <span>{t("common.active")}</span>
                </label>
              </div>
              <div className="col-12">
                <label className="form-label text-uppercase">
                  {t("settings.profile.profile_form.trusted_host")}
                </label>
                <input
                  className="form-control"
                  value={trustedHost}
                  onChange={(e) => setTrustedHost(e.target.value)}
                  placeholder="0.0.0.0/0"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex gap-3 justify-content-center align-items-center">
            <button onClick={saveForm} className="btn btn-primary">
              {t("common.save")}
            </button>
            <button
              onClick={() => {
                navigate(`/profile/${profileId}/detail`);
              }}
              className="btn btn-gray btn-outline-gray"
            >
              {t("common.exit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormConfig;
